import React, { useState, useEffect } from "react";
import logo from "../logo.png";
import "./navbar.css";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Detect scroll
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close menu after clicking a link
  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <nav className={`navbar1 ${scrolled ? "scrolled" : ""}`}>
      
      {/* Logo */}
      <div className="logo">
        <Link to="/" onClick={closeMenu}>
          <img src={logo} alt="Logo" />
        </Link>
      </div>

      {/* Menu */}
      <ul className={`nav-links1 ${isOpen ? "active" : ""}`}>
        <li>
          <Link to="/" onClick={closeMenu}>HOME</Link>
        </li>

        <li>
          <Link to="/about" onClick={closeMenu}>ABOUT</Link>
        </li>

        <li
          className="dropdown1"
          onMouseEnter={() => setDropdown(true)}
          onMouseLeave={() => setDropdown(false)}
        >
          <Link to="/accommodation" onClick={closeMenu}>
            ACCOMMODATION ▾
          </Link>

          <ul className={`dropdown-menu1 ${dropdown ? "show" : ""}`}>
            <li>
              <Link to="/dining" onClick={closeMenu}>Dining</Link>
            </li>

            <li>
              <Link to="/events" onClick={closeMenu}>Events</Link>
            </li>

            <li>
              <Link to="/accommodation" onClick={closeMenu}>Services</Link>
            </li>
          </ul>
        </li>

        <li>
          <Link to="/retreats" onClick={closeMenu}>RETREATS</Link>
        </li>

        <li>
          <Link to="/gallery" onClick={closeMenu}>GALLERY</Link>
        </li>

        <li>
          <Link to="/blog" onClick={closeMenu}>BLOG</Link>
        </li>

        <li>
          <Link to="/rooms" onClick={closeMenu}>ROOMS</Link>
        </li>

        <li>
          <Link to="/contact" onClick={closeMenu}>CONTACT</Link>
        </li>
      </ul>

      {/* Button */}
      <div className="book-btn">
        <Link to="/rooms" onClick={closeMenu}>
          <button>BOOK NOW</button>
        </Link>
      </div>

      {/* Hamburger / Close Icon */}
      <div
        className="menu-toggle"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? "✖" : "☰"}
      </div>
    </nav>
  );
};

export default Navbar;